import { css } from '@emotion/core';
import styled from '@emotion/styled';
import React from 'react';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import IconSvg from '../../common/IconSvg';

export const ItemsImportedTitle = () => (
  <div
    css={css`
      padding-top: 40px;
    `}
  >
    <span>
      <FormattedMessage id="onboarding.advanced.screen8.title" />
    </span>
  </div>
);

export const BodySubtitle = styled.span`
  display: block;
  width: 100%;
  margin-top: 18px;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.colors.blueDark};
`;

export const CustomCard = styled(Card)`
  height: 120px;
  width: 140px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  margin-right: 14px;
  box-shadow: 0px 1px 7px 0 ${({ theme }) => theme.colors.imageBoxShadow};

  background-color: #ffffff;

  /*&.highlighted {
    border-top: 4px solid ${({ theme }) => theme.colors.blueDark};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.blueMed};
    border-right-width: 1px !important;
    cursor: pointer;
  }*/
  & .ant-card-body {
    padding: 0;
  }
  &>.ant-card-cover>span{
    width: 100%;
    margin-top: ${props => 62.6 - props.coverheight}px;
  }

  & .ant-card-body {
    text-align: center;
    font-size: ${({ theme }) => theme.fontSize.medium};
    line-height: ${({ theme }) => theme.lineHeight.medium};
    letter-spacing: normal;
    color: ${({ theme }) => theme.colors.darkBlue};
    padding: 9.4px ${props => (props.bodywidth ? (140 - props.bodywidth) / 2 : 0)}px 0 ${props =>
  props.bodywidth ? (140 - props.bodywidth) / 2 : 0}px;
  }
`;

const SuggestionCard = props => (
  <CustomCard
    coverheight={props.height}
    hoverable
    bodywidth={props.bodywidth ? props.bodywidth : 0}
    cover={<IconSvg type={props.type} height={props.height} width={140} />}
    onClick={e => props.onClick(e)}
  >
    {props.description}
  </CustomCard>
);

SuggestionCard.propTypes = {
  type: PropTypes.string,
  height: PropTypes.number,
  description: PropTypes.string,
  bodywidth: PropTypes.number,
  // clickHandler: PropTypes.func
};

export { SuggestionCard };
